/**
 * Entidade de domínio que representa os dados de um lead fictício capturado
 * pela tela de ativação fake do piloto (HUB-147). Dados reais no banco —
 * apenas o fluxo de captura é fictício (sem plugin de Quiz/Roleta real).
 */
export interface FakeLeadInput {
  readonly name: string;
  readonly email: string;
  readonly consentAccepted: boolean;
}

export interface CapturedLead {
  readonly id: string;
  readonly name: string;
  readonly email: string | null;
}

/**
 * Placeholder não-pessoal enviado no lugar do nome quando o consentimento é
 * recusado. O contrato de `POST /events/:id/leads` exige `name` não-vazio
 * mesmo nesse caminho (HTTP 202 — nenhum `Lead` é criado; o backend audita
 * apenas um hash do payload, nunca o nome em si — CA-11/CA-15, HUB-132).
 */
export const CONSENT_DECLINED_NAME_PLACEHOLDER = 'Participante (consentimento recusado)';

/**
 * Regra de domínio: com o consentimento aceito, nome e email são
 * obrigatórios. Recusar o consentimento nunca bloqueia o envio (LGPD —
 * HUB-201): o participante pode prosseguir na ativação mesmo sem preencher
 * nome/email.
 */
export function isFakeLeadInputValid(input: FakeLeadInput): boolean {
  if (!input.consentAccepted) return true;
  return input.name.trim().length > 0 && input.email.trim().length > 0;
}
